export const GLOBAL = {
    CDN_LINK: 'https://cdn.sc.edu.vn/images',
    CART_STORAGE: 'lisa_cart',
};
